import { inject } from "@angular/core";
import { ADD_MAIN_LINKS } from "../../layouts/config/main-sidenav.config";
import { SETTING_SIDENAV_LINK } from "@app/applications/settings/config/side-nav-links.config";
import { AUTHENTICATION_SIDENAV_LINKS } from "@app/applications/authentication/config/side-nav-links.config";
import { USERS_SIDENAV_LINKS } from "@app/applications/users/config/side-nav-links.config";
import { COMPANY_HIERARCHY_SIDENAV_LINKS } from "@app/applications/company-hierarchy/config/side-nav-links.config";
import { NEWS_SIDENAV_LINK } from "@app/applications/news/config/side-nav-links.config";
import { NOTIFICATION_SETTING_SIDENAV_LINK } from "@app/applications/settings/domains/notification-settings/config/side-nav-links.config";
import { EXPIRATION_SETTING_SIDENAV_LINK } from "@app/applications/settings/domains/expiration-settings/config/side-nav-links.config";
import { STOCK_TYPE_SIDENAV_LINK } from "@app/applications/stock/domains/stock-type/configs/side-nav-links.config";
import { STATISTICS_SIDENAV_LINK } from "@app/applications/stock/domains/stock-statistics/configs/statistics-sidenav-links.config";
import { HOME_SIDENAV_LINKS } from "../../layouts/config/home-sidenav-links.config";

export function provideSideNav() {
  inject(ADD_MAIN_LINKS);
  inject(SETTING_SIDENAV_LINK);
  inject(STOCK_TYPE_SIDENAV_LINK);
  inject(NOTIFICATION_SETTING_SIDENAV_LINK);
  inject(EXPIRATION_SETTING_SIDENAV_LINK);
  inject(NEWS_SIDENAV_LINK);
  inject(AUTHENTICATION_SIDENAV_LINKS);
  inject(COMPANY_HIERARCHY_SIDENAV_LINKS);
  inject(USERS_SIDENAV_LINKS);
  inject(STATISTICS_SIDENAV_LINK);
  inject(HOME_SIDENAV_LINKS);
}
